/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PPDRow = {
    properties: {
        date: {
    type: 'string',
    isRequired: true,
    format: 'date',
},
        total_hours: {
    type: 'number',
    isRequired: true,
    format: 'double',
},
        total_count: {
    type: 'number',
    format: 'int32',
},
        census: {
    type: 'number',
    isRequired: true,
    format: 'int32',
},
        ppd: {
    type: 'number',
    isRequired: true,
    format: 'double',
},
        target_ppd: {
    type: 'number',
    format: 'double',
},
        actual_ppd: {
    type: 'number',
    format: 'double',
},
    },
};